import React from "react";
import {
  message,
  Space,
  Row,
  Col,
  Button,
  Modal,
  Tooltip,
  Checkbox,
  Image,
  Drawer,
  Dropdown,
  Avatar,
  Radio,
  ConfigProvider,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import {
  CloseOutlined,
  DeleteFilled,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { QuestionCircleOutlined } from "@ant-design/icons";
import WareHouseStore from "../store/WareHouseStore";
import withRouter from "../withRouter";
import config from "../config";
import DeleteConfirm from "./DeleteConfirm";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import WarehouseAdd from "../components/WarehouseAdd";

import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import columnIcon from "../assets/images/NewDesign/column.svg";
import editIcon from "../assets/images/NewDesign/editIcon.svg";
import { toJS } from "mobx";

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
  });

  return arr;
};
class WareHouseList extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    // this.renderWarehouseDetails=this.renderWarehouseDetails.bind(this);
    this.wareHouseStore = new WareHouseStore();
    this.companyStore = new CompanyStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      companyId: "",
      loadData: 0,
      companyVal_Lab: "",
      waslModal: false,
      warehouseName: "",
      warehouseId: "",
      openWarehouseForm: false,
      vehicleId: "",
      listDataUpdate: false,
      modalVisible: false,
      deleteOption: 1,
      editData: {},
      openDeleteModal: false,
      deleteData: {},
      showAlertModal: false,
      selectedColumns: [
        {
          // title:
          title: context.translate("_FLEET_USER_USERLIST_COMPANYDDL_"),
          dataIndex: "companyName",
          width: "10%",
          key: "companyName",
          render: (value, record) => {
            return (
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.onEdit(record);
                }}
              >
                {value}
              </Link>
            );
          },
        },
        {
          // title: "Warehouse",
          title: context.translate("_FLEET_DASHBORD_NEWPOI_TYPEDDL_WAREHOUSE_"),
          dataIndex: "warehouse",
          width: "10%",
          key: "warehouse",
        },
        {
          // title: "City",
          title: context.translate("_FLEET_COMPANY_COMPANYDETAIL_CITY_"),
          dataIndex: "city",
          key: "city",
          width: "10%",
        },
        {
          // title: "License Number",
          title: context.translate("_FLEET_DRIVER_DRIVERLIST_LICENCE_"),
          dataIndex: "licenseNo",
          key: "licenseNo",
          width: "10%",
        },
        {
          // title: "Issue Date",
          title: context.translate("_LICENSE_GRID_ISSUE_DATE_"),
          dataIndex: "licenseIssueDate",
          key: "licenseIssueDate",
          width: "10%",
        },
        {
          // title: "Expiry Date",
          title: context.translate("_EXPIRY_DATE_"),
          dataIndex: "licenseExpiryDate",
          key: "licenseExpiryDate",
          width: "10%",
        },

        {
          // title: "Phone",
          title: context.translate("_PHONE_"),
          dataIndex: "phone",
          width: "10%",
          key: "phone",
        },
        {
          // title: "Manager Mobile",
          title: context.translate("_MANAGER_MOBILE_"),
          dataIndex: "managerMobile",
          key: "managerMobile",
          width: "10%",
        },
        {
          // title: "Manager Email",
          title: context.translate("_EMAIL_GRID_"),
          dataIndex: "email",
          key: "email",
          width: "10%",
        },
        {
          // title: "Land Area",
          title: context.translate("_WAREHOUSE_GRID_LAND_AREA_"),
          dataIndex: "landArea",
          key: "landArea",
          width: "10%",
        },
        {
          // title: "WASL Reply",
          // title: context.translate("_WAREHOUSE_WASL_REPLY_"),
          title: context.translate("SFDA Reply"),
          dataIndex: "waslReply",
          key: "waslReply",
          width: "10%",
        },
        {
          // title: "WASL Response",
          // title: context.translate("_WAREHOUSE_WASL_RESPONSE_"),
          title: context.translate("SFDA Response"),
          dataIndex: "waslResponse",
          key: "waslResponse",
          width: "10%",
        },
        {
          // title: "Action",
          title: context.translate("_ACTION_"),
          dataIndex: "Action",
          key: "Action",
          // fixed: "right",
          width: "10%",
          render: (_, record) => {
            return (
              <>
                <Space style={{ display: "flex", alignItems: "center" }}>
                  {/* <Link
                    onClick={(e) => {
                      e.preventDefault();
                      this.onEdit(record);
                    }}
                  >
                    <Tooltip
                      // title="Edit Record"
                      title={this.context.translate("_EDIT_RECORD_")}
                      placement="bottom"
                      color={config.tooltipColorEdit}
                    >
                      <EditFilled />
                    </Tooltip>
                  </Link> */}
                  {/* <DeleteConfirm
                    onConfirm={(e) => {
                      e.preventDefault();
                      this.onDelete(record);
                    }}
                  >
                    <Link>
                      <Tooltip
                        // title="Delete Record"
                        title={this.context.translate("_DELETE_RECORD_")}
                        placement="bottom"
                        color={config.tooltipColorDelete}
                      >
                        <DeleteFilled style={{ color: config.deleteColor }} />
                      </Tooltip>
                    </Link>
                  </DeleteConfirm>

                  <Link
                    onClick={async (e) => {
                      this.setState({ waslModal: true });

                      this.setState({ warehouseName: record.warehouse });

                      this.setState({ warehouseId: record.id });
                    }}
                  >
                    <Tooltip
                      // title="Register in WASL"
                      title={this.context.translate("_REGISTER_IN_WASL_")}
                      color="green"
                    >
                      <PlusOutlined />
                    </Tooltip>
                  </Link> */}

                  <Tooltip
                    // title="Register in WASL"
                    title={this.context.translate("_REGISTER_IN_WASL_")}
                    color="green"
                  >
                    <PlusOutlined
                      style={{
                        cursor: "pointer",
                        fontSize: "15px",
                        marginTop: "5px",
                      }}
                      onClick={async (e) => {
                        this.setState({ waslModal: true });

                        this.setState({ warehouseName: record.warehouse });

                        this.setState({ warehouseId: record.id });
                      }}
                    />
                  </Tooltip>
                  <Tooltip
                    // title="WASL Status"
                    title={this.context.translate("_WASL_STATUS_")}
                    color={config.tooltipColorEdit}
                  >
                    <SearchOutlined
                      style={{
                        cursor: "pointer",
                        fontSize: "15px",
                        marginTop: "5px",
                      }}
                      onClick={async () => {
                        const response =
                          await this.wareHouseStore.getWASLWarehouseStatus(
                            record
                          );
                        console.log("response");

                        if (response) {
                          this.setState({
                            waslInquiryPopup: true,
                            showAlertModal: false,
                            loadData: 1,
                          });
                        } else {
                          this.setState({
                            waslInquiryPopup: false,
                            showAlertModal: true,
                            loadData: 1,
                          });
                        }
                      }}
                    />
                  </Tooltip>
                  <Tooltip
                    title={this.context.translate(
                      "_FLEET_DASHBORD_RULETRIGGER_DELETE_"
                    )}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    />
                  </Tooltip>
                  <Dropdown
                    // overlayClassName="export-dropdown"
                    menu={this.actionColumn}
                    trigger={["click"]}
                  >
                    <Image
                      style={{ cursor: "pointer" }}
                      src={kebabIcon}
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ editData: record });
                      }}
                    ></Image>
                  </Dropdown>
                </Space>
              </>
            );
          },
        },
      ],
    };
    this.newColumns = widthAdderFunc([
      ...this.state.selectedColumns,
      {
        // title: "Address Grid Of Warehouse",
        title: context.translate("_ADDRESS_GRID_OF_WAREHOUSE_"),
        dataIndex: "address",
        key: "address",
      },
      {
        // title: "Latitude",
        title: context.translate("_FLEET_DASHBORD_SETTING_LATITUDE_"),
        dataIndex: "latitude",
        key: "latitude",
      },
      {
        // title: "Longitude",
        title: context.translate("_FLEET_DASHBORD_SETTING_LONGITUDE_"),
        dataIndex: "longitude",
        key: "sensorId",
      },
      {
        // title: "Land Coordinates",
        title: context.translate("_LAND_CORDINATES_"),
        dataIndex: "landCoordinates",
        key: "landCoordinates",
      },
    ]);

    this.menuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => this.setState({ modalVisible: true })}
            >
              {" "}
              <Avatar
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={columnIcon}
              />
              {context.translate("_COLUMNS_")}
            </div>
          ),
          key: "columns",
        },
      ],
    };

    this.actionColumn = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => this.onEdit(this.state.editData)}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={editIcon}
              ></Avatar>
              {context.translate("_FLEET_ROLE_ROLEDETAIL_EDIT_")}
            </div>
          ),
          key: "edit",
        },
      ],
    };
  }

  onEdit = async (record) => {
    const vehicleId = record.id;

    if (vehicleId) {
      this.context.viewStateStore.setWarehouseStates({
        companyId: record.companyId,
      });
      await this.setState({
        vehicleId: vehicleId,
        companyId: record.companyId,
      });
      await this.setState({ openWarehouseForm: true });

      // await this.props.navigate("/warehouseadd/" + vehicleId);
    }
  };

  async onDelete(record, deleteOption) {
    const response = await this.wareHouseStore.deleteRecord({
      companyId: record.companyId,
      warehouseId: record.id,
      waslWarehouseKey: record.waslWarehouseKey,
      option: deleteOption,
    });
    this.setState({ companyId: record.companyId });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ loading: true });
      await this.wareHouseStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: record.companyId,
      });
      this.setState({ openDeleteModal: false });
      // this.handleSearch();
      await this.setState({ loadData: 1 });
      // this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    await this.setState({ column: this.state.selectedColumns });
    this.setState({ pageSize: 50 });
  }

  regiterWarehouse = async (warehouseId) => {
    const data = {
      warehouseId: warehouseId,
    };

    const response = await this.wareHouseStore.addWarehouse(data);
    if (response?.success === "S") {
      message.success(response.message);
      this.handleSearch();
      // this.props.navigate("/warehouselist");
    } else {
      message.error(response.message);
    }
  };
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    // await this.setState({
    //   companyId: comp.value,
    //   pageSize: 50,
    //   currentPage: 1,
    // });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyVal_Lab: singleData });
    // await this.setState({ companyId: comp.value });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.wareHouseStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
    });
    await this.setState({ loadData: 1 });
  }

  responseMsg = async (resp) => {
    if (resp.success == "S") {
      message.success("Warehouse Details Saved");
      await this.setState({ listDataUpdate: true });
      await this.setState({ openWarehouseForm: false });
      // await this.handleSearch();

      //  await this.handleSearch();
      // this.props.navigate("/companyuserlist");
    }
    // else if (resp.data.success == "F0") {
    //   resp.data.errors.map((value) => {
    //     message.error(value["account"]);
    //   });
    // }
    else {
      await this.setState({ listDataUpdate: true });
      message.error(resp.message);
    }
  };

  async componentDidUpdate(prevProps, prevState) {
    if (
      this.state.openWarehouseForm &&
      prevState.openWarehouseForm !== this.state.openWarehouseForm
    ) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 10);
    }

    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setWarehouseStates = this.context.viewStateStore.warehouseObject;

      if (setWarehouseStates.companyId !== "") {
        await this.wareHouseStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          //   searchField: setVehicleStates.searchText,
          companyId: setWarehouseStates.companyId,
        });

        const singleData = await this.companyStore.getCompanyDataById(
          setWarehouseStates.companyId
        );

        await this.setState({ loadList: 1 });

        await this.setState({
          companyVal_Lab: singleData,
          companyId: singleData[0].value,
        });
      }
      await this.setState({ listDataUpdate: false });
    }
  }

  handleCheckboxChange = async (column) => {
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );

      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };
  closeModal = () => {
    this.setState({ openWarehouseForm: false, companyId: "" });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.wareHouseStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };
  renderWarehouseDetails() {
    const data = toJS(this.wareHouseStore?.warehouseStatus || []);

    if (!Array.isArray(data) || data.length === 0) {
      return <div>No data found</div>;
    }

    const warehouse = data[0];
    console.log(warehouse);
    const invBoxStyle = {
      border: "1px solid #e0e0e0",
      borderRadius: 6,
      padding: "10px 15px",
      margin: "5px 12px 12px 0px",
      background: "#fafafa",
    };
    const invBoxStyle1 = {
      border: "1px solid #e0e0e0",
      borderRadius: 6,
      padding: "10px 15px",
      margin: "0px 20px 12px 12px",
      background: "#fafafa",
    };

    const rowStyle = {
      display: "flex",
      marginBottom: 0,
    };

    const labelStyle = {
      fontWeight: "600",
      width: 110,
    };

    const valueStyle = {
      marginLeft: 5,
    };

    return (
      <div>
        <div style={invBoxStyle1}>
          <div style={rowStyle}>
            <span style={labelStyle}>Name :</span>
            <span style={valueStyle}>{warehouse.name}</span>
          </div>

          <div style={rowStyle}>
            <span style={labelStyle}>City :</span>
            <span style={valueStyle}>{warehouse.city}</span>
          </div>

          <div style={rowStyle}>
            <span style={labelStyle}>Latitude :</span>
            <span style={valueStyle}>{warehouse.latitude}</span>
          </div>

          <div style={rowStyle}>
            <span style={labelStyle}>Longitude :</span>
            <span style={valueStyle}>{warehouse.longitude}</span>
          </div>

          <div style={rowStyle}>
            <span style={labelStyle}>License No. :</span>
            <span style={valueStyle}>{warehouse.licenseNumber}</span>
          </div>

          <div style={rowStyle}>
            <span style={labelStyle}>Issue Date :</span>
            <span style={valueStyle}>{warehouse.licenseIssueDate}</span>
          </div>

          <div style={rowStyle}>
            <span style={labelStyle}>Expiry Date :</span>
            <span style={valueStyle}>{warehouse.licenseExpiryDate}</span>
          </div>

          <div style={rowStyle}>
            <span style={labelStyle}>Reference No. :</span>
            <span style={valueStyle}>{warehouse.referenceNumber}</span>
          </div>
        </div>

        <div style={rowStyle}>
          <span style={labelStyle}>Inventories :</span>
        </div>

        <div
          style={{ maxHeight: "400px", overflowY: "auto", paddingLeft: "10px" }}
        >
          {warehouse.inventories?.map((inv, index) => (
            <div key={index} style={invBoxStyle}>
              <div style={{ fontWeight: "600", marginBottom: 5 }}>
                Inventory {index + 1}
              </div>

              <div style={rowStyle}>
                <span style={labelStyle}>Name :</span>
                <span style={valueStyle}>{inv.name}</span>
              </div>

              <div style={rowStyle}>
                <span style={labelStyle}>Category :</span>
                <span style={valueStyle}>{inv.storingCategory}</span>
              </div>

              <div style={rowStyle}>
                <span style={labelStyle}>Number :</span>
                <span style={valueStyle}>{inv.number}</span>
              </div>
              <div style={rowStyle}>
                <span style={labelStyle}>Reference No.:</span>
                <span style={valueStyle}>{inv.referenceNumber}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  onChange={(value) => this.handleChange(value)}
                  style={{ width: 200 }}
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                />
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => {
                      this.refreshList();
                      this.setState({
                        searchField: "",
                        userStatus: "",
                        userType: "",
                      });
                    }}
                  />
                </Tooltip>

                <Dropdown
                  overlayClassName="export-dropdown"
                  menu={this.menuProps}
                >
                  <Image
                    style={{
                      height: 18,
                      alignItems: "center",
                      marginInlineEnd: "20px",
                    }}
                    src={kebabIcon}
                  />
                </Dropdown>

                <Button
                  className="addButtonClass"
                  onClick={() => {
                    this.setState({ openWarehouseForm: true, vehicleId: "" });
                  }}
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              </Space>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            total={this.wareHouseStore?.total}
            columns={this.state.selectedColumns}
            pageSize={this.state.pageSize}
            dataSource={this.wareHouseStore?.wareHouse}
            loading={this.wareHouseStore?.loading}
            onChange={this.handleTableChange}
          />

          {/* <Modal
            title={
              <span>
                <QuestionCircleOutlined style={{ color: "red" }} />
                &nbsp;
                {this.context.translate("_CONFIRM_")}
              </span>
            }
            width={400}
            open={this.state.waslModal}
            onCancel={() => this.setState({ waslModal: false })}
            footer={[
              <div style={{ padding: 10 }}>
                <Button
                  // key="yes"
                  onClick={(e) => {
                    this.regiterWarehouse(this.state.warehouseId);

                    this.setState({ waslModal: false });
                  }}
                  type="primary"
                >
                  {this.context.translate("_FLEET_RULEDETAIL_ACTIVEDDL_YES_")}
                </Button>
                <Button
                  // key="no"
                  onClick={() => this.setState({ waslModal: false })}
                >
                  {this.context.translate("_FLEET_RULELIST_CRONRULE_NO_")}
                </Button>
              </div>,
            ]}
          >
            <p style={{ margin: "0px 20px" }}>
              {" "}
              {this.context.translate("_DOYOU_WANT_TO_REGISTER_")}{" "}
              {this.state.warehouseName} {this.context.translate("_IN_WASL_")}
            </p>
          </Modal> */}

          {this.state.waslModal && (
            <Modal
              maskClosable={false}
              title={
                <div className="confirmStatusTitle">
                  <span>{this.context.translate("_CONFIRM_")}</span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ waslModal: false })}
                  />
                </div>
              }
              className="update-statusModal"
              description="Are you sure to change this status?"
              centered
              open={this.state.waslModal}
              footer={null}
              // onOk={this.confirmStatus}
              width={400}
              closable={false}
            >
              <div className="confirmStatusText">
                <p>
                  {this.context.translate("_DOYOU_WANT_TO_REGISTER_")}{" "}
                  {this.state.warehouseName}{" "}
                  {this.context.translate("_IN_WASL_")}
                </p>
              </div>
              <div className="confirmStatusButtons">
                <Button
                  onClick={() => this.setState({ waslModal: false })}
                  className="confirmStatusCancelButton"
                >
                  {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                </Button>

                <Button
                  className="confirmStatusOkButton"
                  onClick={(e) => {
                    this.regiterWarehouse(this.state.warehouseId);
                    this.setState({ waslModal: false });
                  }}
                >
                  {this.context.translate("_FLEET_RULEDETAIL_ACTIVEDDL_YES_")}
                </Button>
              </div>
            </Modal>
          )}

          {this.state.openWarehouseForm && (
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openWarehouseForm}
              footer={false}
              placement={
                this.context.locale.language === "arabic" ? "left" : "right"
              }
              title={
                <div className="formTitle">
                  {this.context.translate("_WAREHOUSE_DETAILS_")}
                  <p className="formDescription">
                    {this.context.translate("_WAREHOUSE_DETAILS_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ openWarehouseForm: false })}
              onCancel={() =>
                this.setState({ openWarehouseForm: false, companyId: "" })
              }
            >
              <div style={{ height: "100%" }}>
                <WarehouseAdd
                  companyId={this.state.companyId}
                  vehicleId={this.state.vehicleId}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </Drawer>
          )}

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          {this.state.openDeleteModal && (
            <Modal
              maskClosable={false}
              title={
                <div className="deleteModalTitle">
                  <span>
                    {this.context.translate(
                      "_FLEET_COMPANY_COMPANYLIST_DELETE_"
                    )}
                  </span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ openDeleteModal: false })}
                  />
                </div>
              }
              className="deleteModal"
              description="Are you sure you want to delete this Item? This action cannot be undone."
              centered
              open={this.state.openDeleteModal}
              footer={null}
              width={450}
              closable={false}
            >
              <div className="deleteModalText">
                <p>{this.context.translate("_DELETE_STATUS_")}</p>
              </div>

              {/* NEW: Delete choice options */}
              <div style={{ marginBottom: 20 }}>
                <ConfigProvider
                  theme={{
                    components: {
                      Radio: {
                        colorPrimary: "rgba(217, 45, 32, 0.7)", // dot color
                        colorPrimaryHover: "rgba(217, 45, 32, 0.7)", // hover border
                        colorPrimaryActive: "rgba(217, 45, 32, 0.7)", // focus ring
                      },
                    },
                  }}
                >
                  <Radio.Group
                    className="deleteRadioGroup"
                    onChange={
                      (e) => this.setState({ deleteOption: e.target.value }) // 0 or 1
                    }
                    value={this.state.deleteOption}
                  >
                    <Radio value={1}>Delete from WASL only</Radio>
                    <Radio value={2}>Delete from WASL & Portal</Radio>
                  </Radio.Group>
                </ConfigProvider>
              </div>

              <div className="deleteModalButtons">
                <Button
                  className="deleteModalCancelButton"
                  onClick={() => this.setState({ openDeleteModal: false })}
                >
                  {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                </Button>

                <Button
                  className="deleteModalOkButton"
                  onClick={() =>
                    this.onDelete(
                      this.state.deleteData,
                      this.state.deleteOption
                    )
                  }
                >
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </Button>
              </div>
            </Modal>
          )}
          <Modal
            width={350}
            className="alert-model"
            title={
              <div>
                {" "}
                <i
                  style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                  class="bi bi-exclamation-triangle"
                ></i>{" "}
                {this.context.translate("_FLEET_ALERT_")}
              </div>
            }
            open={this.state.showAlertModal}
            onOk={() => this.setState({ showAlertModal: false })}
            onCancel={() => this.setState({ showAlertModal: false })}
            okText="OK"
            cancelText="Cancel"
            footer={[
              <Button
                type="primary"
                onClick={() => this.setState({ showAlertModal: false })}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>,
            ]}
          >
            <p>
              {JSON.stringify(
                toJS(this.wareHouseStore?.warehouseStatus),
                null,
                2
              )}
            </p>
          </Modal>

          <Modal
            width={550}
            className="alert-model"
            title={this.context.translate("_INFORMATION_")}
            open={this.state.waslInquiryPopup}
            onOk={() => this.setState({ waslInquiryPopup: false })}
            onCancel={() => this.setState({ waslInquiryPopup: false })}
            okText="OK"
            cancelText="Cancel"
            footer={null}
          >
            <div>
              {/* formatted data */}
              {this.renderWarehouseDetails()}
            </div>
          </Modal>
        </div>
      </>
    );
  }
}
WareHouseList.contextType = StoreContext;
export default observer(withRouter(WareHouseList));
